<template>
<div class="work row sm-block">



 <div class="workLeft col-6 col-sm-12">
<div class="overlay"><h1>Mon Travail</h1></div>
<hr>


<div class="loading" v-if="!ready"><div class="loader"></div></div>


<transition name="fadeSlide" >
  <div :key="projects">

<li class="workItem" v-for="(project, index) in projects" :id="`project-${index}`" @mouseover="changeImage(index)">
  <router-link :to="{name:'projet', params:{slug: project.slug}}" class="workTitle">
    <div class="projectTitle">{{project.title.rendered}}</div>
  </router-link>
  <router-link :to="{name:'projet', params:{slug: project.slug}}"  class="workDescription">
    <div class="projectDescription">{{project.acf.description}}</div>
  </router-link>
</li>
</div>
</transition>

</div>

 <div class="workRight col-6 sm-hide">
   <div class="workBack">

   </div>
   <transition name="fade" >
     <div :key="activeImage">
 <div class="workPhoto">
   <div class="workImage" :style="`background-image:url('${activeImage}')`"></div>
   <div v-for="(project, index) in projects" class="workImage" :style="`background-image:url('${project.acf.image1.url}'); visibility:hidden;`">

   </div>
   <!-- <img :src="activeImage" :alt="activeImageName"> -->
 </div>
</div>
</transition>
 </div>
</div>
</template>

<script>

import axios from 'axios'

export default {

  data:function(){
    return {
      projects:[],
      activeImage:'',
      activeImageName:'',
      ready:false

    }
  },
  mounted(){
    let revealTlWork= new TimelineMax()
    revealTlWork.delay(1.5);
    revealTlWork.from('.work h1', 1, {
      y: '-100%', opacity:0,
      ease: Expo.easeOut
    },);
    revealTlWork.fromTo('.work hr', 1, {
      opacity:'0',width:'0',
      ease: Expo.easeOut
    },{
      opacity:'1',width:'50%',
      ease: Expo.easeOut
    },"-=1");
    axios
     .get('https://www.nicolas-noel.net/api/index.php/wp-json/wp/v2/posts?categories=2&per_page=100')
     .then(response => (this.ready=true, this.projects = response.data, this.activeImage = response.data[0].acf.image1.url, this.activeImageName = response.data[0].acf.image1.name));


  },
  methods:{
    changeImage(index){
      this.activeImage=this.projects[index].acf.image1.url
      this.activeImageName=this.projects[index].acf.image1.name
    }
  }

}
</script>


<style scoped>

.loading {
		/* -webkit-animation: rotation 1s infinite linear; */
    width: 100%;
    margin-top: 3rem;

    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 9999;
    font-size: 2rem;
}

.loader,
.loader:before,
.loader:after {
  border-radius: 50%;

}
.loader {

  color: #ffffff;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: #222;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.1em 5.1em;
  transform-origin: 5.1em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: #222;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/*
@-webkit-keyframes rotation {
		from {
				-webkit-transform: rotate(0deg);
		}
		to {
				-webkit-transform: rotate(359deg);
		}
} */

.work{
  min-height: 100vh;
  background-color: #222;

}

.workLeft{
  padding-left: 7.5rem;
  background-image: url('../assets/portrait-pattern-crop.png');
  background-position: top;
  background-size:contain;
  background-repeat: no-repeat;
  padding-bottom: 3rem;
}

h1 {
  color: #fff;
  font-size: 8rem;
  font-weight: bold;
  margin-bottom: 3rem;
  margin-top: 12.5rem;

}

hr{
  margin-left: 0;
  border: solid 1px #dec8b2;
  width: 50% ;
}


.workItem:hover .projectTitle{
  color: #dec8b2;
  transition: 0.3s;
}


.projectTitle{
    transition: 0.3s;
  font-size: 2rem;
  text-transform: uppercase;
  font-family: 'Cormorant', serif;
  color: white;
  line-height: 3rem;
  font-weight: bold;
}

.projectDescription{
  font-size: 1rem;
    text-transform: uppercase;
    color: #888;
      font-family: 'Poppins', sans-serif;
}

.workRight{
  height: 100vh;
  position: relative;

}

.workBack{
  position: fixed;
 width: calc(25% + 6.25rem);
 height: 100vh;
 background-color: #dec8b2;
 right:0;
}

.workPhoto{
  top:50vh;
  transform:  translateY(-50%);
  position: fixed;
  right:0;
  /* padding: 6.25rem 0 6.25rem 0; */
  text-align: right;
  height: calc(100vh - 12.5rem);
  overflow: hidden;
  width: 50%;
}

.workImage{
  width: 100%;
  height:100%;
  background-size: cover;
}

.workImage:hover{

}

.workPhoto img{

height:100%;
}


.fade-enter-active, .fade-leave-active {
  transition: 1s;

}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.fadeSlide-enter-active, .fadeSlide-leave-active {
  transition: 1s;

}
.fadeSlide-enter, .fadeSlide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-100px);
}


@media all and (max-width: 736px) {
  .workLeft{
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .work{
    text-align: center;
  }
  hr{
    width: 50%;
    margin: auto;
  }
  .projectTitle{
    font-size: 3rem;
    line-height: 4.5rem;
  }

  .projectDescription{
        font-size: 1.5rem;
  }
}
</style>
